export default __webpack_public_path__ + "static/education-159af4178eb76bb812d9a8343f407d79.png";